const WBS_REGEX_PATTERNS = [
    /^[A-Z]{4}[0-9]{4}-[0-9]{2}$/,
    /^[A-Z]{4}[0-9]{4}-[0-9]{2}-[0-9]{2}$/,
    /^[A-Z]{4}[0-9]{4}-[0-9]{2}-[0-9]{2}-[0-9]{2}$/,
    /^[A-Z]{4}[0-9]{4}-[0-9]{2}-[0-9]{2}-[0-9]{2}-[0-9]{4}$/,
    /^[A-Z]{4}[0-9]{8}$/,
    /^[0-9]{9}$/,
    /^[A-Z]{3}[0-9]{5}-[0-9]{2}$/,
    /^[A-Z]{3}[0-9]{5}-[0-9]{2}-[0-9]{2}$/,
    /^[A-Z]{3}[0-9]{5}-[0-9]{2}-[0-9]{2}-[0-9]{2}$/,
    /^[A-Z]{3}[0-9]{5}-[0-9]{2}-[0-9]{2}-[0-9]{2}-[0-9]{4}$/,
    /^[A-Z]{4}[0-9]{4}-[0-9]{2}-[0-9]{2}-[0-9]{1}$/,
    /^[A-Z]{4}[0-9]{4}-[0-9]{2}-[0-9A-Z]{2}-[0-9]{2}-[0-9]{4}$/,
    /^[0-9]{3}-P[0-9]{5}$/,
    /^[A-Z]{1}\.[0-9]{5}-[A-Z]{2}-[0-9]{2}$/
]

/**
 * @param {string} value - The WBS code to check
 * @returns {boolean} True if the code matches any valid pattern
 */
const handleWbsCodePatternCheck = (value) => {
    return WBS_REGEX_PATTERNS.some((rx) => rx.test(value))
}

/**
 * @param {string} value - The WBS code to validate
 * @param {{error: function}} helpers - Joi validation helpers object with error function
 * @returns {string} The validated WBS code
 * @throws {Error} If value is empty
 */
const wbsCodeValidation = (value, helpers) => {
    if (!value) {
        throw new Error("any.required")
    }
    // validate value adheres to a pattern
    const isValid = handleWbsCodePatternCheck(value)

    if (!isValid) {
        return helpers.error("string.pattern")
    }

    // verify the value is an existing and valid wbs code

    // TODO: Logic verifying code with swift API

    return value
}

export default wbsCodeValidation;
